module.exports = __webpack_public_path__ + "img/emotional-development2.bfa3ed63.png";